import {
  Component,
  EventEmitter,
  Inject,
  OnInit,
  Output,
  viewChild,
} from '@angular/core'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog'
import { MatCard, MatCardHeader, MatCardTitle } from '@angular/material/card'
import { MatOption } from '@angular/material/core'
import { MatSelect, MatSelectChange } from '@angular/material/select'
import { MatButtonModule } from '@angular/material/button'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatIconModule } from '@angular/material/icon'
import { MatInputModule } from '@angular/material/input'
import { provideNgxMask } from 'ngx-mask'
import { SnackbarCustomService } from '../../../../shared/components/snackbar/snackbar-custom.service'
import { VehicleTypeService } from '../../../../core/services/vehicle/vehicle-type/vehicle-type.service'
import { ServiceTypeService } from '../../../../core/services/service/service-type/service-type.service'
import { ServiceSpecificationService } from '../../../../core/services/service/service-specification/service-specification.service'
import { LocationService } from '../../../../core/services/location/location/location.service'
import { TariffTypeService } from '../../../../core/services/tariff/tariff-type/tariff-type.service'
import { TariffService } from '../../../../core/services/tariff/tariff/tariff.service'
import { DriverTypeService } from '../../../../core/services/driver/driver-type/driver-type.service'
import { CurrencyInputDirective } from '../../../../shared/directives/currencyInput'
import { ResponseRequestModel } from '../../../../core/models/response.model'
import { convertCurrency } from '../../../../shared/utils/utils'
import { MatCheckbox } from '@angular/material/checkbox'
import { MatDivider } from '@angular/material/divider'
import { ItinerariesItemProposalCreateComponent } from '../../../itineraries/item-proposal/itineraries-item-proposal-create/itineraries-item-proposal-create.component'
import { ModalTariffProposalComponent } from '../../../tariff/modal-tariff-proposal/modal-tariff-proposal.component'
import moment from 'moment/moment'
import { IntegerInputDirective } from '../../../../shared/directives/IntegerInput'
import { ItinerariesItemProposalEditComponent } from '../../../itineraries/item-proposal/itineraries-item-proposal-edit/itineraries-item-proposal-edit.component'
import { DecimalInputDirective } from '../../../../shared/directives/decimalInput'
import {
  MatAccordion,
  MatExpansionPanel,
  MatExpansionPanelHeader,
  MatExpansionPanelTitle,
} from '@angular/material/expansion'
import {
  MatDatepicker,
  MatDatepickerInput,
  MatDatepickerToggle,
} from '@angular/material/datepicker'
import { SearchTariffProposalComponent } from '../../../tariff/search-tariff-proposal/search-tariff-proposal.component'
import { CommissionDividerService } from '../../../../core/services/price-quote/commission-divider/commission-divider.service'
import { ProposalItemService } from '../../../../core/services/proposal/proposal-item/proposal-item.service'
import { SearchTariffContractComponent } from '../../../tariff/search-tariff-contract/search-tariff-contract.component'

@Component({
  selector: 'item-proposal-edit-form',
  imports: [
    MatProgressSpinner,
    ReactiveFormsModule,
    MatCard,
    MatCardHeader,
    MatCardTitle,
    MatOption,
    MatSelect,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    FormsModule,
    CurrencyInputDirective,
    MatCheckbox,
    MatDivider,
    ItinerariesItemProposalCreateComponent,
    IntegerInputDirective,
    DecimalInputDirective,
    MatAccordion,
    MatDatepicker,
    MatDatepickerInput,
    MatDatepickerToggle,
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
    SearchTariffProposalComponent,
    ItinerariesItemProposalEditComponent,
    SearchTariffContractComponent,
  ],
  templateUrl: './item-contract-edit-form.component.html',
  styleUrl: './item-contract-edit-form.component.scss',
  providers: [
    TariffService,
    TariffTypeService,
    DriverTypeService,
    LocationService,
    ServiceTypeService,
    ServiceSpecificationService,
    VehicleTypeService,
    provideNgxMask(),
  ],
  standalone: true,
})
export class ItemContractEditFormComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private driverTypeService: DriverTypeService,
    private locationService: LocationService,
    private serviceTypeService: ServiceTypeService,
    private serviceSpecificationService: ServiceSpecificationService,
    private vehicleTypeService: VehicleTypeService,
    private commissionDividerService: CommissionDividerService,
    private proposalItemService: ProposalItemService,
    private snackbar: SnackbarCustomService,
    private dialogRef: MatDialogRef<ItemContractEditFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
  ) {
    // this.idClient = data.idClient
    // if (data && data.edit) {
    //   this.edit = true
    //   this.item = data.item
    // }
    // console.log('data: ', data.item)
    this.proposal = data.proposalInfo
    this.idClient =
      this.proposal.subClienteId > 0
        ? this.proposal.subClienteId
        : this.proposal.clienteId
    if (data && data.edit) {
      this.edit = true
      this.item = data.item
      this.viewOnly = this.item.statusId == 1
    }
  }

  // implements OnInit {
  // constructor(
  //   private formBuilder: FormBuilder,
  //   private driverTypeService: DriverTypeService,
  //   private locationService: LocationService,
  //   private serviceTypeService: ServiceTypeService,
  //   private serviceSpecificationService: ServiceSpecificationService,
  //   private vehicleTypeService: VehicleTypeService,
  //   private snackbar: SnackbarCustomService,
  //   private dialogRef: MatDialogRef<ItemProposalEditFormComponent>,
  //   @Inject(MAT_DIALOG_DATA) public data: any,
  //   private dialog: MatDialog,
  // ) {
  //   console.log('data', data)
  //   this.proposal = data.proposalInfo
  //   this.idClient =
  //     this.proposal.subClienteId > 0
  //       ? this.proposal.subClienteId
  //       : this.proposal.clienteId
  //   if (data && data.edit) {
  //     this.edit = true
  //     this.item = data.item
  //     this.viewOnly = this.item.statusId == 1
  //   }
  // }

  @Output() response = new EventEmitter()
  datepickerStart = viewChild<MatDatepicker<any>>('dateStart')
  datepickerEnd = viewChild<MatDatepicker<any>>('dateEnd')

  viewOnly: boolean = false
  proposal: any = {}
  loadingInfo: boolean = true
  tariffSelected: any = {}

  edit: boolean = false
  idClient: number = -1
  item: any = { user: false, data: [] }
  form: FormGroup = new FormGroup({})
  loading: boolean = false
  listLocation: any[] = []
  listTypeVehicle: any[] = []
  listTypeDriver: any[] = []
  listTypeService: any[] = []
  listItineraries: any[] = []
  listServiceSpecification: any[] = []
  listCommission: any[] = [
    { value: 0, description: 'Tgmob', disabled: false },
    { value: 1, description: 'Cliente', disabled: true },
    { value: 2, description: 'Personalizado', disabled: false },
  ]

  commissionDividerClient: any = {
    taxa: 0,
    divisor: 0,
    comissao: 0,
  }

  commissionDividerTg: any = {
    taxa: 0,
    divisor: 0,
    comissao: 0,
  }

  ngOnInit(): void {
    this.getLocation()
    this.getTypeService()
    this.getTypeVehicle()
    this.getTypeDriver()
    this.createForm()
    this.fillForm(this.item)
    this.getCommissionDivider()
  }

  getCommissionDivider(id: number = -1) {
    if (id == -1) {
      this.commissionDividerService.getCommissionDividerDefault().subscribe({
        next: (response: ResponseRequestModel) => {
          this.commissionDividerTg = {
            taxa:
              response && response.data && response.data.taxa
                ? response.data.taxa
                : 0,
            divisor:
              response && response.data && response.data.divisor
                ? response.data.divisor
                : 1,
            comissao:
              response && response.data && response.data.comissao
                ? response.data.comissao
                : 0,
          }
          // this.commissionDividerTg = {
          //   taxa: response.data.taxa,
          //   divisor: response.data.divisor,
          //   comissao: response.data.comissao,
          // }
          if (!this.edit) {
            this.fillCommission(this.commissionDividerTg)
          }
        },
        error: (err: ResponseRequestModel) => {
          console.error(err)
        },
        complete: () => {},
      })
    } else {
      this.commissionDividerService
        .getCommissionDividerbyClientId(id)
        .subscribe({
          next: (response: ResponseRequestModel) => {
            if (response.data) {
              this.commissionDividerClient = {
                taxa:
                  response && response.data && response.data.taxa
                    ? response.data.taxa
                    : 0,
                divisor:
                  response && response.data && response.data.divisor
                    ? response.data.divisor
                    : 1,
                comissao:
                  response && response.data && response.data.comissao
                    ? response.data.comissao
                    : 0,
              }
              this.listCommission[1].disabled = false
              if (!this.edit) {
                this.form.get('typeCommission')!.setValue('C')
                this.fillCommission(this.commissionDividerClient)
              }
            } else {
              this.commissionDividerClient = {
                taxa: 0,
                divisor: 0,
                comissao: 0,
              }
              this.listCommission[1].disabled = true
              if (!this.edit) {
                this.fillCommission(this.commissionDividerTg)
                this.form.get('typeCommission')!.setValue('T')
              }
            }
          },
          error: (err: ResponseRequestModel) => {
            console.error(err)
          },
          complete: () => {},
        })
    }
  }

  fillCommission(commission: any, clear: boolean = false) {
    if (clear == false) {
      this.form
        .get('commission')!
        .setValue(convertCurrency(commission.comissao))
      this.form.get('commission')!.disable()
      this.form.get('typeCommission')!.disable()
      this.form.get('tax')!.setValue(convertCurrency(commission.taxa))
      this.form.get('tax')!.disable()
      this.form.get('divider')!.setValue(convertCurrency(commission.divisor))
      this.form.get('divider')!.disable()
      this.form.get('typeCommission')!.disable()
    } else {
      this.form.get('commission')!.setValue(convertCurrency(1))
      this.form.get('commission')!.enable()
      this.form.get('tax')!.setValue(convertCurrency(1))
      this.form.get('tax')!.enable()
      this.form.get('divider')!.setValue(convertCurrency(1))
      this.form.get('divider')!.enable()
    }
  }

  onSelectionChangeType(event: MatSelectChange) {
    if (event.value == 0) {
      this.fillCommission(this.commissionDividerTg)
    } else if (event.value == 1) {
      this.fillCommission(this.commissionDividerClient)
    } else {
      this.fillCommission('', true)
    }
    this.calculateValues()
  }

  getLocation() {
    this.locationService.listLocation().subscribe({
      next: (response: ResponseRequestModel) => {
        this.listLocation = response.data
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => {},
    })
  }

  getTypeService() {
    this.serviceTypeService.listServiceType().subscribe({
      next: (response: ResponseRequestModel) => {
        this.listTypeService = response.data
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => {},
    })
  }

  getTypeVehicle() {
    this.vehicleTypeService.listVehicleType().subscribe({
      next: (response: ResponseRequestModel) => {
        this.listTypeVehicle = response.data
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => {},
    })
  }

  getTypeDriver() {
    this.driverTypeService.listDriverType().subscribe({
      next: (response: ResponseRequestModel) => {
        this.listTypeDriver = response.data
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => {},
    })
  }

  onSelectionChangeServiceSpecification(event: MatSelectChange) {
    this.form.get('specificationService')!.setValue('')
    this.form.get('driverType')!.setValue('')
    this.form.get('vehicleType')!.setValue('')
    this.form.get('vehicleType')!.clearValidators()
    this.form.get('driverType')!.clearValidators()
    this.form.get('vehicleType')!.disable()
    this.form.get('driverType')!.disable()
    if (event.value >= 0) {
      this.getServiceSpecification(event.value)
    }
  }

  getServiceSpecification(idType: number, idService: number = -1) {
    this.listServiceSpecification = []
    this.serviceSpecificationService
      .listServiceSpecificationByType(idType)
      .subscribe({
        next: (response: ResponseRequestModel) => {
          this.listServiceSpecification = response.data ?? []
          if (idService >= 0) {
            this.checkService(
              this.listServiceSpecification.find((ele) => {
                return ele.id == idService
              }),
            )
          }
        },
        error: (err: ResponseRequestModel) => {
          console.error(err)
        },
        complete: () => {},
      })
  }

  checkForm() {
    if (this.form.valid) {
      return true
    } else {
      return false
    }
  }

  close() {
    this.dialogRef.close()
  }

  getDescription(id: number, list: any[]) {
    let index = list.findIndex((ele) => {
      return ele.id == id
    })
    return index > -1 ? list[index].descricao : ''
  }

  fillForm(item: any) {
    // console.log('🔄 PAI - Iniciando fillForm', item);

    this.tariffSelected = JSON.parse(
      JSON.stringify({
        id: item.tarifarioId,
        origemId: item.origemId,
        destinoId: item.destinoId,
        tipoServicoId: item.tipoServicoId,
        servicoId: item.servicoId,
        tipoVeiculoId: item.tipoVeiculoId,
        tipoMotoristaId: item.tipoMotoristaId,
        origin: item.itinerarios?.find((i: any) => i.trecho === 'O'),
        destination: item.itinerarios?.find((i: any) => i.trecho === 'D'),
      }),
    )

    // console.log('📤 PAI - Dados enviados para filho:', this.tariffSelected);

    // 2. Forçar detecção de mudanças
    setTimeout(() => {
      // 3. Preencher campos do pai APÓS o filho ter processado
      this.form.patchValue({
        cost: convertCurrency(item.custo),
        saleUnit: convertCurrency(item.valorUnitario),
        // ... outros campos
      })
      // console.log('✅ PAI - Campos do pai preenchidos');
    }, 100)

    this.proposalItemService
      .getProposalItembyId(item.itemPropostaId)
      .subscribe({
        next: (res) => {
          // console.log("Resposta do fillForm: ", res.data)
          if (res.data) {
            const updatedItem = res.data
            if (updatedItem) {
              if (updatedItem.tarifarioId != '') {
                this.tariffSelected = {
                  origem: updatedItem.origem,
                  origemId: updatedItem.origemId,

                  destino: updatedItem.destino,
                  destinoId: updatedItem.destinoId,

                  tipoServico: updatedItem.tipoServico,
                  tipoServicoId: updatedItem.tipoServicoId,

                  servico: updatedItem.servico,
                  servicoId: updatedItem.servicoId,

                  tipoVeiculo: updatedItem.tipoVeiculo,
                  tipoVeiculoId: updatedItem.tipoVeiculoId,

                  tipoMotorista: updatedItem.tipoMotorista,
                  tipoMotoristaId: updatedItem.tipoMotoristaId,

                  tarifarioId: updatedItem.tarifarioId,
                  id: updatedItem.tarifarioId,
                }

                let destination = updatedItem.itinerarios?.find((ele: any) => {
                  return ele.trecho == 'D'
                })
                if (destination) {
                  this.tariffSelected.destination = {
                    cep: destination.cep,
                    logradouro: destination.logradouro,
                    numero: destination.numero,
                    complemento: destination.complemento,
                    bairro: destination.bairro,
                    cidade: destination.cidade,
                    estado: destination.estado,
                  }
                }

                let origin = updatedItem.itinerarios?.find((ele: any) => {
                  return ele.trecho == 'O'
                })
                if (origin) {
                  this.tariffSelected.origin = {
                    cep: origin.cep,
                    logradouro: origin.logradouro,
                    numero: origin.numero,
                    complemento: origin.complemento,
                    bairro: origin.bairro,
                    cidade: origin.cidade,
                    estado: origin.estado,
                  }
                }

                this.form
                  .get('cost')!
                  .setValue(convertCurrency(updatedItem.custo))

                this.form
                  .get('saleUnit')!
                  .setValue(convertCurrency(updatedItem.valorUnitario))
                this.form
                  .get('saleOvertime')!
                  .setValue(convertCurrency(updatedItem.valorHoraVenda))
                this.form
                  .get('saleKmExtra')!
                  .setValue(convertCurrency(updatedItem.valorKmVenda))

                this.form
                  .get('dateStart')!
                  .setValue(
                    moment(updatedItem.dataInicio, 'DD/MM/YYYY').toDate(),
                  )
                this.form
                  .get('timeStart')!
                  .setValue(
                    !updatedItem.horaInicio
                      ? ''
                      : updatedItem.horaInicio.slice(0, 5),
                  )
                this.form
                  .get('dateEnd')!
                  .setValue(
                    moment(updatedItem.dataFinal, 'DD/MM/YYYY').toDate(),
                  )
                this.form
                  .get('timeEnd')!
                  .setValue(
                    !updatedItem.horaFinal
                      ? ''
                      : updatedItem.horaFinal.slice(0, 5),
                  )

                this.form
                  .get('isCourtesy')!
                  .setValue(updatedItem.isCortesia == 'S' ? true : false)
                this.form
                  .get('isCommission')!
                  .setValue(updatedItem.isComissiona == 'S' ? true : false)
                this.form
                  .get('isExchange')!
                  .setValue(updatedItem.isPermuta == 'S' ? true : false)

                this.form
                  .get('numVehicle')!
                  .setValue(updatedItem.quantidadeVeiculos)
                this.form
                  .get('numPeople')!
                  .setValue(updatedItem.quantidadePassageiros)

                this.form
                  .get('saleTotal')!
                  .setValue(convertCurrency(updatedItem.valorVenda))
                this.form
                  .get('taxValue')!
                  .setValue(convertCurrency(updatedItem.valorTaxa))
                this.form
                  .get('saleTotalTax')!
                  .setValue(convertCurrency(updatedItem.valorComTaxa))

                this.form
                  .get('typeCommission')!
                  .setValue(updatedItem.tipoComissao)
                this.fillCommission({
                  taxa: updatedItem.taxa,
                  divisor: updatedItem.divisor,
                  comissao: updatedItem.comissao,
                })
                this.blockField(true)
              }
            }
          } else {
            // console.log('Item não encontrado na proposta.')
            return
          }
        },
        error: (err) => {
          console.error('Erro ao buscar item da proposta:', err)
        },
      })
  }

  createModel() {
    return {
      origem: this.tariffSelected.origem,
      destino: this.tariffSelected.destino,
      tipoServico: this.tariffSelected.tipoServico,
      servico: this.tariffSelected.servico,
      tipoVeiculo: this.tariffSelected.tipoVeiculo,
      tipoMotorista: this.tariffSelected.tipoMotorista,

      tarifario: this.tariffSelected,
      tarifarioId: this.tariffSelected.id,

      origemId: this.tariffSelected.origemId,
      destinoId: this.tariffSelected.destinoId,
      tipoServicoId: this.tariffSelected.tipoServicoId,
      servicoId: this.tariffSelected.servicoId,
      tipoVeiculoId: this.tariffSelected.tipoVeiculoId,
      tipoMotoristaId: this.tariffSelected.tipoMotoristaId,

      tipoComissao: this.form.get('typeCommission')?.value,
      comissao: this.form.get('commission')?.value,
      divisor: this.form.get('divider')?.value,
      taxa: this.form.get('tax')?.value,

      custo: this.form.get('cost')?.value,
      custoKmExtra: this.form.get('costKmExtra')?.value,
      custoHoraExtra: this.form.get('costOvertime')?.value,

      custoFormatado: `R$ ${convertCurrency(convertCurrency(this.form.get('cost')?.value))}`,
      custoKmExtraFormatado: `R$ ${convertCurrency(convertCurrency(this.form.get('costKmExtra')?.value))}`,
      custoHoraExtraFormatado: `R$ ${convertCurrency(convertCurrency(this.form.get('costOvertime')?.value))}`,

      vendaUnitario: this.form.get('saleUnit')?.value,
      saleHoraExtra: this.form.get('saleOvertime')?.value,
      saleKmExtra: this.form.get('saleKmExtra')?.value,

      vendaUnitarioFormatado: `R$ ${this.form.get('saleUnit')?.value}`,
      saleHoraExtraFormatado: `R$ ${convertCurrency(convertCurrency(this.form.get('saleOvertime')?.value))}`,
      saleKmExtraFormatado: `R$ ${convertCurrency(convertCurrency(this.form.get('saleKmExtra')?.value))}`,

      dataInicio: this.form.get('dateStart')?.value,
      dataInicioFormatada: moment(this.form.get('dateStart')!.value).format(
        'DD/MM/YYYY',
      ),
      horaInicio: this.form.get('timeStart')?.value,

      dataFinal: this.form.get('dateEnd')?.value,
      dataFinalFormatada: moment(this.form.get('dateEnd')!.value).format(
        'DD/MM/YYYY',
      ),
      horaFinal: this.form.get('timeEnd')?.value,

      isPermuta: this.form.get('isExchange')?.value,
      isCortesia: this.form.get('isCourtesy')?.value,
      isComisionado: this.form.get('isCommission')?.value,

      numVeiculos: parseInt(this.form.get('numVehicle')?.value),
      numPessoas: parseInt(this.form.get('numPeople')?.value),

      vendaSemTaxa: this.form.get('saleTotal')?.value,
      valorTaxa: this.form.get('taxValue')?.value,
      venda: this.form.get('saleTotalTax')?.value,

      vendaSemTaxaFormatado: `R$ ${convertCurrency(this.form.get('saleTotal')?.value)}`,
      valorTaxaFormatado: `R$ ${convertCurrency(this.form.get('taxValue')?.value)}`,
      vendaFormatado: `R$ ${convertCurrency(this.form.get('saleTotalTax')?.value)}`,

      intinerarios: this.listItineraries,
    }
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      tariff: [''],

      isCourtesy: [false],
      isCommission: [false],
      isExchange: [false],

      dateStart: ['', [Validators.required]],
      timeStart: ['', [Validators.required]],
      dateEnd: ['', [Validators.required]],
      timeEnd: ['', [Validators.required]],

      typeCommission: [0],
      commission: ['', [Validators.required]],
      divider: ['', [Validators.required]],
      tax: ['', [Validators.required]],

      numVehicle: [1, [Validators.min(1), Validators.required]],
      numPeople: [1, [Validators.min(1), Validators.required]],

      cost: ['', [Validators.required]],
      sale: [''],
      // costOvertime: ['', [Validators.required]],
      // costKmExtra: ['', [Validators.required]],

      saleUnit: ['', [Validators.required]],
      saleOvertime: ['', [Validators.required]],
      saleKmExtra: ['', [Validators.required]],

      saleTotal: ['', [Validators.required]],
      taxValue: ['', [Validators.required]],
      saleTotalTax: ['', [Validators.required]],
    })
  }

  onSelectionChangeService(event: MatSelectChange) {
    this.form.get('driverType')!.setValue('')
    this.form.get('vehicleType')!.setValue('')
    let specificationService = this.listServiceSpecification.find((ele) => {
      return ele.id == event.value
    })
    this.checkService(specificationService)
  }

  checkService(specificationService: any) {
    if (specificationService) {
      if (
        specificationService.exigeVeiculo &&
        specificationService.exigeVeiculo.toLowerCase() == 's'
      ) {
        this.form.get('vehicleType')!.setValidators(Validators.required)
        this.form.get('driverType')!.setValidators(Validators.required)
        this.form.get('vehicleType')!.enable()
        this.form.get('driverType')!.enable()
      } else {
        this.form.get('vehicleType')!.clearValidators()
        this.form.get('driverType')!.clearValidators()
        this.form.get('vehicleType')!.disable()
        this.form.get('driverType')!.disable()
      }
    }
  }

  addTariff() {
    const dialogRef = this.dialog.open(ModalTariffProposalComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '100vw',
      width: '100vw',
      maxHeight: '100vh',
      height: '100vh',
      panelClass: 'dialog-fullscreen',
      data: {
        idClient: this.idClient,
        item: this.tariffSelected,
        multiSelect: false,
      },
    })
    dialogRef.componentInstance.responseSingle.subscribe((response) => {
      if (response) {
        if (response.remove == false) {
          this.tariffSelected = response.selection
          this.fillTariff(this.tariffSelected)
        } else {
          this.tariffSelected = {}
          this.form.get('tariff')!.setValue('')
          this.clearTariff()
        }
      }
    })
  }

  fillTariff(item: any) {
    let label = `O: ${item.origem} | D:  ${item.destino} | Serviço:  ${item.servico} | Custo:  R$ ${convertCurrency(item.custo)}`
    this.form.get('tariff')!.setValue(label)
    this.getServiceSpecification(item.tipoServicoId)
    this.form.get('origin')!.setValue(item.origemId)
    this.form.get('destination')!.setValue(item.destinoId)
    this.form.get('serviceType')!.setValue(item.tipoServicoId)
    this.form.get('specificationService')!.setValue(item.servicoId)
    this.form.get('vehicleType')!.setValue(item.tipoVeiculoId)
    this.form.get('driverType')!.setValue(item.tipoMotoristaId)
    this.form.get('cost')!.setValue(convertCurrency(item.custo))
    this.form
      .get('costOvertime')!
      .setValue(convertCurrency(item.custoHoraExtra))
    this.form.get('costKmExtra')!.setValue(convertCurrency(item.custokmExtra))
    this.form.get('origin')?.disable()
    this.form.get('destination')?.disable()
    this.form.get('serviceType')?.disable()
    this.form.get('specificationService')?.disable()
    this.form.get('vehicleType')?.disable()
    this.form.get('driverType')?.disable()
    this.form.get('cost')?.disable()
    this.form.get('costOvertime')?.disable()
    this.form.get('costKmExtra')?.disable()
  }

  clearTariff() {
    this.form.get('origin')!.setValue('')
    this.form.get('origin')?.enable()
    this.form.get('destination')!.setValue('')
    this.form.get('destination')?.enable()
    this.form.get('serviceType')!.setValue('')
    this.form.get('serviceType')?.enable()
    this.form.get('specificationService')!.setValue('')
    this.form.get('specificationService')?.enable()
    this.form.get('vehicleType')!.setValue('')
    this.form.get('vehicleType')?.enable()
    this.form.get('driverType')!.setValue('')
    this.form.get('driverType')?.enable()
    this.form.get('cost')!.setValue('')
    this.form.get('cost')?.enable()
    this.form.get('costOvertime')!.setValue('')
    this.form.get('costOvertime')?.enable()
    this.form.get('costKmExtra')!.setValue('')
    this.form.get('costKmExtra')?.enable()
  }

  getList(list: any[]): void {
    this.listItineraries = list
  }

  openDatepicker(type: 'dateStart' | 'dateEnd') {
    if (type == 'dateStart') {
      this.datepickerStart()?.open()
    } else if (type == 'dateEnd') {
      this.datepickerEnd()?.open()
    }
  }

  selectTariff(element: any) {
    if (element.id != -1) {
      this.form.get('cost')?.setValue(convertCurrency(element.custo))
      this.form
        .get('costOvertime')
        ?.setValue(convertCurrency(element.custoHoraExtra))
      this.form
        .get('costKmExtra')
        ?.setValue(convertCurrency(element.custokmExtra))
      this.blockField(true)
      this.calculateValues()
    } else {
      // this.form.get('cost')?.setValue(convertCurrency(0))
      // this.form.get('costOvertime')?.setValue(convertCurrency(0))
      // this.form.get('costKmExtra')?.setValue(convertCurrency(0))
      this.blockField()
    }
    this.tariffSelected = element
    this.calculateValues()
  }

  blockField(block: boolean = false) {
    if (block) {
      this.form.get('isCourtesy')?.disable()
      this.form.get('typeCommission')!.disable()
      this.form.get('isExchange')?.disable()
      this.form.get('isCommission')?.disable()
      this.form.get('cost')?.disable()
      this.form.get('costOvertime')?.disable()
      this.form.get('costKmExtra')?.disable()
      this.form.get('numVehicle')?.disable()
      this.form.get('numPeople')?.disable()

      this.form.get('sale')?.disable()
      this.form.get('saleOvertime')?.disable()
      this.form.get('saleKmExtra')?.disable()

      this.form.get('saleUnit')?.disable()
      this.form.get('saleTotal')?.disable()
      this.form.get('saleTotalTax')?.disable()
      this.form.get('taxValue')?.disable()
    } else {
      this.form.get('cost')?.enable()
      this.form.get('costOvertime')?.enable()
      this.form.get('costKmExtra')?.enable()
    }
    this.form.get('dateStart')?.disable()
    this.form.get('dateEnd')?.disable()
    this.form.get('timeStart')?.disable()
    this.form.get('timeEnd')?.disable()
  }

  getValueNumber(value: string | number) {
    if (typeof value == 'string') {
      return parseFloat(value.replaceAll('.', '').replaceAll(',', '.'))
    } else if (typeof value == 'number') {
      return value
    } else {
      return 0.0
    }
  }

  calculateValues() {
    let divider = this.getValueNumber(this.form.get('divider')?.value)
    let tax = this.getValueNumber(this.form.get('tax')?.value)
    let commission = this.getValueNumber(this.form.get('commission')?.value)
    let cost = this.getValueNumber(this.form.get('cost')?.value)
    let costKm = this.getValueNumber(this.form.get('costKmExtra')?.value)
    let costTime = this.getValueNumber(this.form.get('costOvertime')?.value)
    let vehicles = parseInt(this.form.get('numVehicle')?.value)

    let saleUnit = parseFloat((cost + cost / divider).toFixed(2))
    let saleKm = parseFloat((costKm + costKm / divider).toFixed(2))
    let saleTime = parseFloat((costTime + costTime / divider).toFixed(2))
    let sale = parseFloat((saleUnit * vehicles).toFixed(2))
    let saleTax = parseFloat((sale + (sale * tax) / 100).toFixed(2))
    let taxValue = parseFloat((saleTax - sale).toFixed(2))

    this.form.get('saleUnit')?.setValue(convertCurrency(saleUnit))
    this.form.get('saleKmExtra')?.setValue(convertCurrency(saleKm))
    this.form.get('saleOvertime')?.setValue(convertCurrency(saleTime))

    this.form.get('saleTotal')?.setValue(convertCurrency(sale))
    this.form.get('taxValue')?.setValue(convertCurrency(taxValue))
    this.form.get('saleTotalTax')?.setValue(convertCurrency(saleTax))
  }
}
